import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";

export const LoadingStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
    middleContent: {
        ...OnboardingStyle(theme).middleContent,
        alignItems: 'center',
        justifyContent: 'center',
    }
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepLoading/loading.styles.ts